import { Box, useColorModeValue } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import DashboardHeader from "../header";
// import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const DashboardContent = () => {
  const bg = useColorModeValue("#F1F6FA", "gray.800");
  
  return (
    <Box pl={6} bgColor={bg} width="100%" overflow="auto">
      <DashboardHeader />
      <Box mt={6} pr={6} mb={6}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default DashboardContent;
